import React from 'react';
import { Typography, Grid, Container, Button, Box, Card, Divider, Badge } from '@mui/material';


const Block5 = (props) => {
    const trademarkSymbol = '\u2122';
    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={'xl'}
            sx={{
                marginTop: "80px",
                marginBottom: "80px"
            }}
        >
            <Divider sx={{ margin: "25px" }} />

            <Grid container item md={12} justifyContent={'center'} direction={'row'} alignItems={'stretch'}
                sx={{
                    padding: { md: "140px" }
                }}>
                <Grid item md={4} justifyContent={'center'} sx={{ height: "500px" }}>
                    <Card
                        sx={{
                            padding:

                                "43px 30px 58px"
                            ,
                            height: "100%"
                        }}
                    >
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Boosts Tire Sales
                            </Typography>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                }}
                            >
                                According to NADA, “Customers service their vehicles where they buy their tires!”
                            </Typography>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"
                                }}
                            >

                                Tirefax boosts tire sales, increases customer retention levels for dealers and auto service retailers as we identify ‘tire safety issues.' Tirefax remotely tracks tires of customers, vehicle owners and fleets keeping them safe on the road by getting them back into service.

                            </Typography>
                        </Grid>

                    </Card>
                </Grid>
                <Grid item md={4} justifyContent={'center'}>
                    <Card sx={{ padding: "43px 30px 58px", height: "100%" }}>
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Mitigates Liabilities
                            </Typography>

                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"

                                }}
                            >
                                Tirefax Safety Alerts will mitigate liabilities for auto dealerships, auto service retailers as well as fleets and rental agencies. Tirefax acts as a reconditioning tool– thereby mitigating risk and liabilities for customers, employees and others.
                            </Typography>
                        </Grid>

                    </Card>
                </Grid>
                <Grid item md={4} justifyContent={'center'}>
                    <Card sx={{ padding: "43px 30px 58px", height: "100%" }}>
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Pings Customers
                            </Typography>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#FE753E",
                                    fontWeight: "bold",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                ‘Tiretrax Tracks Tires’ – Notifications to Return to Service Department
                            </Typography>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"

                                }}
                            >
                                Get your customers and vehicle owners off-the-road and back into service by tracking tires with 'Tiretrax' by Tirefax. Our Tirefax database is able to send real-time notifications to vehicle owners when a tire safety issued is identified. If you are a dealer, auto service retailer, fleet or rental agency - you don't want customers, vehicle owners or employees driving on tires with 'tire safety issues' - tires with a known history of 'tire failures' that have lead  to serious accidents involving catostrophic injuries and even death?
                            </Typography>
                        </Grid>

                    </Card>
                </Grid>
                <Grid item md={4} justifyContent={'center'}>
                    <Card sx={{ padding: "43px 30px 58px", height: "100%" }}>
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Forensic Hotline
                            </Typography>

                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"

                                }}
                            >
                                Subscribers have direct access to our forensic facility by calling our  TIREFAX FORENSIC HOTLINE to answer any questions  or concerns you might have about tires.
                            </Typography>
                        </Grid>

                    </Card>
                </Grid>
                <Grid item md={4} justifyContent={'center'}>
                    <Card sx={{ padding: "43px 30px 58px", height: "100%" }}>
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Scans Tires in Seconds
                            </Typography>

                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"

                                }}
                            >
                                In just minutes, new subscribers experience easy training via the Tirefax instructional video. Tirefax scans the VIN & tires TIN in just seconds.
                            </Typography>
                        </Grid>

                    </Card>
                </Grid>
                <Grid item md={4} justifyContent={'center'}>
                    <Card sx={{ padding: "43px 30px 58px", height: "100%" }}>
                        <Grid item md={12} justifyContent={'center'}>
                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "25px",
                                    color: "#FE753E",
                                    margin: "20px 25px 20px 0px",

                                }}
                            >
                                Tirefax Scans all Passenger Vehicle Tires
                            </Typography>

                            <Typography
                                align='center'
                                sx={{
                                    fontSize: "16px",
                                    color: "#808291",
                                    margin: "20px 25px 20px 0px",
                                    textAlign: "justify"

                                }}
                            >
                                Tirefax scans tires on all passenger cars, SUV’s, passenger trucks and vans.
                            </Typography>
                        </Grid>

                    </Card>
                </Grid>

            </Grid>
        </Container>
    )
}

export default Block5;